import { EmptyState, Spinner } from '@nexo/ui';
import { Bookmark, Hash } from 'lucide-react';
import { Link } from 'react-router';
import { TeamHeader } from '../../layouts/TeamHeader';
import { useTeam } from '../../layouts/TeamContext';
import { useSaved } from '../../lib/queries';
import { channelLabel } from '../channels/ChannelSidebar';
import { MessageItem } from './MessageItem';
import { RemindersList } from './RemindersList';
import { useTranslation } from 'react-i18next';

/** Messages I bookmarked in this team, to come back to later. */
export function SavedPage() {
  const { team, channels, openThread } = useTeam();
  const saved = useSaved(team.id);
  const { t } = useTranslation();

  return (
    <>
      <TeamHeader>
        <Bookmark className="size-[18px] shrink-0 text-muted" />
        <h1 className="text-[17px] font-semibold tracking-tight">{t('Guardados')}</h1>
        <p className="min-w-0 truncate text-[13px] text-muted max-sm:hidden">
          {t('Solo tú ves esta lista')}
        </p>
      </TeamHeader>
      <div className="scrollbar-thin min-h-0 flex-1 overflow-y-auto pb-6">
        <RemindersList teamId={team.id} />
        {saved.isPending ? (
          <div className="flex justify-center py-10 text-muted">
            <Spinner />
          </div>
        ) : !saved.data?.length ? (
          <EmptyState
            icon={<Bookmark className="size-6" />}
            title={t('No has guardado nada')}
            description={t('Pasa el ratón por un mensaje y pulsa el marcador para guardarlo aquí.')}
          />
        ) : (
          saved.data.map((message) => {
            const channel = channels.find((c) => c.id === message.channelId);
            return (
              <section key={message.id} className="border-b border-border pt-3 pb-2">
                <Link
                  to={`/app/t/${team.id}/c/${message.channelId}`}
                  onClick={() => message.parentId && openThread(message.parentId)}
                  className="mx-6 inline-flex items-center gap-1 text-xs font-medium text-muted hover:text-accent"
                >
                  <Hash className="size-3.5" />
                  {channel ? channelLabel(channel) : t('Conversación')}
                  {message.parentId && t(' · en un hilo')}
                </Link>
                <MessageItem message={message} compact={false} inThread />
              </section>
            );
          })
        )}
      </div>
    </>
  );
}
